<div class="full" >
  <mat-toolbar>
    <button mat-icon-button class="example-icon" (click)="drawer.toggle()" aria-label="Example icon-button with menu icon">
      <mat-icon>menu</mat-icon>
    </button>

    <button mat-button style="font-size: 18pt">
      <img *ngIf="LabImg && LabImg != '' " [src]="'data:image/png;base64,'+LabImg"  height="50" style="padding: 5px;"/>
      <span style="padding-left: 5px;">{{fullLabName}}</span>

    </button>

    <span class="nav-spacer"></span>

      <!--Logo HERE-->

    <span class="nav-spacer"></span>
    <span style="font-weight: normal; font-size: small; color: darkred;">Session Expires: {{UserExpire }} </span>

    <!--Notification(s) is Disabled for Initial Release-->
     <button mat-icon-button>
       <mat-icon [matBadge]="pendingNotifications" matBadgeColor="warn" matBadgeSize="small" [matMenuTriggerFor]="menu" *ngIf="pendingNotifications>0">notifications</mat-icon>
       <mat-icon [matMenuTriggerFor]="menu" *ngIf="pendingNotifications==0">notifications</mat-icon>
     </button>
     <mat-menu #menu="matMenu" >
       <button mat-menu-item *ngIf="pendingNotifications==0">
         <span style="font-size: 8pt">THERE ARE NO NOTIFICATIONS</span>
       </button>

       <button mat-menu-item *ngIf="pendingNotifications>0" (click)="showChangesDialog()">
         <span style="font-size: 8pt"><b>{{pendingNotifications}}</b> PENDING CHANGE<span *ngIf="pendingNotifications>1">s</span> REQUESTS.</span>
       </button>
       <mat-divider></mat-divider>

       <button  mat-menu-item routerLink="/dashboard/detail/history" (click)="setDisplayState('CHANGEREQHISTORY')">
         <mat-icon style="margin-right: 3px;">history</mat-icon>
         <span style="font-size: 8pt">VIEW CHANGE REQUESTS HISTORY</span>
       </button>

     </mat-menu>


      <button mat-button [matMenuTriggerFor]="usrMenu">
        <mat-icon *ngIf="user.OTHER_DEPTS.length>0">switch_account</mat-icon>
        {{user.FirstName}} {{user.LastName}}
      </button>
      <mat-menu #usrMenu="matMenu">

      <button mat-menu-item *ngIf="user.CurrentDept!=user.Dept" (click)="switchDept(user.Dept)"> <mat-icon>biotech</mat-icon> {{user.Dept}}</button>
      <span *ngFor="let dept of user.OTHER_DEPTS">
        <button mat-menu-item  (click)="switchDept(dept)" *ngIf="user.CurrentDept != dept" > <mat-icon>biotech</mat-icon> {{dept?.toUpperCase()}}</button>
      </span>
      <mat-divider *ngIf="user.OTHER_DEPTS.length>0"></mat-divider>
      <button mat-menu-item (click)="doLogout()"> <mat-icon>logout</mat-icon> Logout</button>


    </mat-menu>
  </mat-toolbar>

  <mat-drawer-container style="flex-grow : 1;">
    <mat-drawer #drawer mode="side" opened style="width: 230px">

      <button mat-button style="width: 100%;text-align: left" routerLink="/dashboard/reports" (click)="setDisplayState('REPORTS')" [style]="this.mainDisplayState==='REPORTS'? ' background-color:#E0E0E0;': ''">
        <mat-icon style="margin-right: 3px;">source</mat-icon>
        <span [style]="this.mainDisplayState==='REPORTS'? 'text-decoration: underline;': ''">REPORTS DASHBOARD</span>
      </button>

      <button mat-button style="width: 100%;text-align: left" routerLink="/dashboard/incidents" (click)="setDisplayState('INCIDENTS')" [style]="this.mainDisplayState==='INCIDENTS'? ' background-color:#E0E0E0;': ''">
        <mat-icon style="margin-right: 3px;">summarize</mat-icon>
        <span [style]="this.mainDisplayState==='INCIDENTS'? 'text-decoration: underline;': ''">INCIDENTS DASHBOARD</span>
      </button>

      <button mat-button style="width: 100%;text-align: left"  (click)="openStatsDashboard()" [style]="this.mainDisplayState==='STATDASHBOARD'? ' background-color:#E0E0E0;': ''">
        <mat-icon style="margin-right: 3px;">insights</mat-icon>
        <span [style]="this.mainDisplayState==='MANAGE_EMAIL'? 'text-decoration: underline;': ''">GUN ANALYSIS DASHBOARD</span>
      </button>

      <button mat-button style="width: 100%;text-align: left" routerLink="/dashboard/email" (click)="setDisplayState('MANAGE_EMAIL')" [style]="this.mainDisplayState==='MANAGE_EMAIL'? ' background-color:#E0E0E0;': ''">
        <mat-icon style="margin-right: 3px;">email</mat-icon>
        <span [style]="this.mainDisplayState==='MANAGE_EMAIL'? 'text-decoration: underline;': ''">MANAGE EMAIL LIST</span>
      </button>

      <button *ngIf="user.isSuperAdmin=='Y'" mat-button style="width: 100%;text-align: left" routerLink="/dashboard/settings/places" (click)="setDisplayState('MANAGE_LOCATIONS')" [style]="this.mainDisplayState==='MANAGE_LOCATIONS'? ' background-color:#E0E0E0;': ''">
        <mat-icon style="margin-right: 3px;">location_on</mat-icon>
        <span [style]="this.mainDisplayState==='MANAGE_LOCATIONS'? 'text-decoration: underline;': ''">MANAGE LOCATIONS</span>
      </button>

      <div style="text-align: center; color: lightgray; font-size: x-small">
        SITE VERSION {{NIBIN_VERSION}}
        <br />
        <a style="text-align: center; color: blue; font-size: x-small" href="/NIBIN Release Notes_Latest.pdf">
          Release Notes
        </a>
      </div>


    </mat-drawer>
    <mat-drawer-content>
      <router-outlet></router-outlet>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

